var map = {
	"./Black_Account_Icons-01.png": 607,
	"./Black_Account_Icons-02.png": 608,
	"./Black_Account_Icons-03.png": 609,
	"./Black_Account_Icons-04.png": 610,
	"./Black_Account_Icons-05.png": 611,
	"./Black_Account_Icons-06.png": 612,
	"./Black_Account_Icons-07.png": 613,
	"./Black_Account_Icons-08.png": 614,
	"./Black_Account_Icons-09.png": 615,
	"./Black_Account_Icons-10.png": 616,
	"./Black_Account_Icons-11.png": 617,
	"./Black_Account_Icons-12.png": 618,
	"./Black_Account_Icons-13.png": 619,
	"./Black_Account_Icons-14.png": 620,
	"./FilePresentOutlined.svg": 621,
	"./accuracyAccountsDemo_downloadMT4.jpg": 622,
	"./accuracyAccountsReal_downloadMT4.jpg": 623,
	"./alert@2x.svg": 624,
	"./apple-brands.svg": 625,
	"./arrow_up_from_box.svg": 626,
	"./bankWire.svg": 627,
	"./bdswissDemo_downloadMT4.png": 628,
	"./bdswissGlobalDemo_downloadMT4.png": 629,
	"./bdswissGlobalReal02_downloadMT4.png": 630,
	"./bdswissGlobalReal03_downloadMT4.png": 631,
	"./bdswissGlobalReal04_downloadMT4.png": 632,
	"./bdswissGlobalReal05_downloadMT4.png": 633,
	"./bdswissGlobalReal_downloadMT4.png": 634,
	"./bdswissGlobalReal_downloadMT5.png": 635,
	"./bdswissReal02_downloadMT4.png": 636,
	"./bdswissReal03_downloadMT4.png": 637,
	"./bdswissReal04_downloadMT4.png": 638,
	"./bdswissReal05_downloadMT4.png": 639,
	"./bdswissReal_downloadMT4.png": 640,
	"./bdswissReal_downloadMT5.png": 641,
	"./bdswissSCDemo_downloadMT4.png": 642,
	"./bdswissSCReal01_downloadMT4.png": 643,
	"./bdswissSCReal02_downloadMT4.png": 644,
	"./bdswissSCReal03_downloadMT4.png": 645,
	"./bdswissSCReal04_downloadMT4.png": 646,
	"./bdswissSCReal05_downloadMT4.png": 647,
	"./bdswiss_grey.png": 648,
	"./bdswiss_white.png": 649,
	"./bg-image-affiliate.png": 650,
	"./bitwallet-bdSwiss-dark.svg": 651,
	"./bitwallet-bdSwiss-light.svg": 652,
	"./bitwallet-swissMarkets-dark.svg": 653,
	"./bitwallet-swissMarkets-light.svg": 654,
	"./card.svg": 655,
	"./check_circle.png": 656,
	"./chf.png": 657,
	"./competitions.png": 658,
	"./complimentary@2x.svg": 659,
	"./control-radio-off.png": 660,
	"./control-radio-on.png": 661,
	"./crypto.svg": 662,
	"./cvv.svg": 663,
	"./deposit-card.svg": 664,
	"./diners.png": 665,
	"./dkk.png": 666,
	"./document-upload-failure-dark.png": 667,
	"./document-upload-failure-light.png": 668,
	"./document-upload-success-black.png": 669,
	"./document-upload-success-dark.png": 670,
	"./document-upload-success-light.png": 671,
	"./documents-empty-dark.png": 672,
	"./documents-empty-light.png": 673,
	"./downloadPdf-light.png": 674,
	"./downloadPdf.png": 675,
	"./dpWorldTourChampionship-dark.svg": 676,
	"./dpWorldTourChampionship-light.svg": 677,
	"./eWallet.svg": 678,
	"./eur.png": 679,
	"./exp-date.svg": 680,
	"./fees@2x.svg": 681,
	"./filterIcon.png": 682,
	"./gbp.png": 683,
	"./icon-add-account.svg": 410,
	"./icon-appstore@2x.png": 684,
	"./icon-arrow-right-dark.png": 685,
	"./icon-arrow-right-light.png": 686,
	"./icon-bank-wire.svg": 687,
	"./icon-checkbox.svg": 688,
	"./icon-close-dark.svg": 689,
	"./icon-close-light.svg": 690,
	"./icon-close.png": 691,
	"./icon-contact-callback@2x.png": 692,
	"./icon-contact-callback@2x.svg": 693,
	"./icon-contact-chat@2x.png": 411,
	"./icon-contact-chat@2x.svg": 412,
	"./icon-contact-email@2x.png": 694,
	"./icon-contact-email@2x.svg": 695,
	"./icon-contact-faqs@2x.png": 696,
	"./icon-contact-faqs@2x.svg": 697,
	"./icon-contact-oneOnOneSession@2x.png": 698,
	"./icon-contact-telegram@2x.png": 699,
	"./icon-contact-whatsapp@2x.png": 700,
	"./icon-crypto.svg": 701,
	"./icon-document.svg": 702,
	"./icon-facebook@2x.png": 703,
	"./icon-google-play@2x.png": 704,
	"./icon-notification.svg": 705,
	"./icon-profile-big.svg": 706,
	"./icon-profile.svg": 707,
	"./icon-spoa.svg": 708,
	"./icon-swapFree.svg": 709,
	"./icon-telegram@2x.png": 710,
	"./icon-twitter@2x.png": 711,
	"./icon_accounts_dashboard.svg": 712,
	"./icon_logout_dashboard.svg": 713,
	"./icon_notification_dashboard.svg": 714,
	"./icon_profilesettings_dashboard.svg": 715,
	"./icon_support_dashboard.svg": 716,
	"./icon_transaction_dashboard.svg": 717,
	"./jcb.png": 718,
	"./knet-logo.png": 413,
	"./languages.png": 719,
	"./limit-failure-dark.png": 720,
	"./limit-failure-light.png": 721,
	"./logo-accuracy.png": 722,
	"./logo-bdstrading-white.svg": 723,
	"./logo-bdstrading.svg": 724,
	"./logo-bdswiss-white.svg": 725,
	"./logo-bdswiss.png": 726,
	"./logo-bdswiss.svg": 727,
	"./logo-equityflow-black.png": 728,
	"./logo-equityflow-white.png": 729,
	"./logo-facebook.png": 730,
	"./logo-google.png": 731,
	"./logo-google.svg": 732,
	"./logo-lydian-black.png": 733,
	"./logo-lydian-black.svg": 734,
	"./logo-lydian-white.svg": 735,
	"./logo-regalx-white.png": 736,
	"./logo-regalx.png": 737,
	"./logo-skyground-black.svg": 738,
	"./logo-skyground-white.svg": 739,
	"./logo-swissmarkets-white.svg": 740,
	"./logo-swissmarkets.png": 741,
	"./logo-swissmarkets.svg": 742,
	"./logo-tauromarkets-black.png": 743,
	"./logo-tauromarkets-white.png": 744,
	"./logo-tauromarkets-white2.png": 745,
	"./logo-tauromarkets-white2.svg": 746,
	"./logo-valutamarkets.png": 747,
	"./lydian/login-bg.png": 1220,
	"./lydian/logo.svg": 1221,
	"./lydian/lydian-trading-academy-coming_soon.png": 1222,
	"./lydian/lydian-trading-academy.png": 1223,
	"./lydian/lydian-watermark.png": 434,
	"./lydian/trading-academy-logo.svg": 435,
	"./lydian/user-icon.svg": 1224,
	"./maestro.png": 748,
	"./mastercard.png": 749,
	"./mastercard_logo_icon.svg": 750,
	"./mercedesCup-dark.svg": 751,
	"./mercedesCup-light.svg": 752,
	"./mobile/accounts.svg": 1225,
	"./mobile/more.svg": 1226,
	"./mobile/notifications.svg": 1227,
	"./mobile/payments.svg": 1228,
	"./nationalIdBR.png": 753,
	"./nationalIdES.jpg": 754,
	"./nationalIdIT.jpg": 755,
	"./nationalIdZA.png": 756,
	"./no-trades-dark.png": 757,
	"./no-trades-light.png": 758,
	"./no-trading-signals-dark.png": 759,
	"./nok.png": 760,
	"./notifications-empty-dark.png": 761,
	"./notifications-empty-light.png": 762,
	"./onlineBanking.svg": 763,
	"./onlineDeposit.svg": 764,
	"./page-not-found-dark.svg": 414,
	"./page-not-found-light.svg": 415,
	"./payment-failure-dark.png": 765,
	"./payment-failure-light.png": 766,
	"./payment-pending-dark.png": 767,
	"./payment-pending-light.png": 768,
	"./payment-success-dark.png": 769,
	"./payment-success-light.png": 770,
	"./payments-history-empty-dark.png": 771,
	"./payments-history-empty-light.png": 772,
	"./phone_verification.png": 773,
	"./place1-leadership.png": 774,
	"./place2-leadership.png": 775,
	"./place3-leadership.png": 776,
	"./pln.png": 777,
	"./pof-bankStatement.png": 778,
	"./pof-bankStatementPOF.png": 779,
	"./pof-card-back.png": 780,
	"./pof-card.png": 781,
	"./pof-cardStatement.png": 782,
	"./pof-other.png": 783,
	"./pof-proofOfResidence.png": 784,
	"./pof-swiftCopyPaymentAdvice.png": 785,
	"./pof-virtualCard.png": 786,
	"./poi-document.png": 787,
	"./poi-drivingLicense-back.png": 788,
	"./poi-drivingLicense.png": 789,
	"./poi-id-back.png": 790,
	"./poi-id.png": 791,
	"./poi-passport.png": 792,
	"./por-bankStatementPOR.png": 793,
	"./por-document.png": 794,
	"./por-proofOfResidence.png": 795,
	"./por-utilityBill.png": 796,
	"./priority@2x.svg": 797,
	"./referAndEarn.png": 798,
	"./regalxDemo_downloadMT4.png": 799,
	"./regalxReal01_downloadMT4.png": 800,
	"./regalxReal02_downloadMT4.png": 801,
	"./regalxReal03_downloadMT4.png": 802,
	"./regalxReal04_downloadMT4.png": 803,
	"./regalxReal05_downloadMT4.png": 804,
	"./register-referral-light.png": 805,
	"./sek.png": 806,
	"./sign-up.png": 807,
	"./spaceship.png": 808,
	"./spreads@2x.svg": 809,
	"./support@2x.svg": 810,
	"./swissmarketsDemo_downloadMT4.png": 811,
	"./swissmarketsReal02_downloadMT4.png": 812,
	"./swissmarketsReal_downloadMT4.png": 813,
	"./tauroDemo01DownloadMT4.jpg": 814,
	"./tauroReal01DownloadMT4.jpg": 815,
	"./technicalIndicator-ebook.png": 816,
	"./technicalIndicatorItem.svg": 817,
	"./telegram-dark.png": 818,
	"./telegram.png": 819,
	"./trading-alerts-tradingAlerts-dark.png": 820,
	"./trading-alerts-tradingAlerts-light.png": 821,
	"./tradingPsychology-ebook.png": 822,
	"./tradingPsychologyItem.svg": 823,
	"./transfer-external.svg": 824,
	"./transfer-internal.svg": 825,
	"./transfer-spoa.svg": 826,
	"./unlockYourTradingPotentialBanner/education_desktop.webp": 537,
	"./unlockYourTradingPotentialBanner/education_mobile.webp": 538,
	"./upload-bankStatement-error.png": 827,
	"./upload-bankStatement-success.png": 828,
	"./upload-bankStatement.png": 829,
	"./upload-document-dark.png": 830,
	"./upload-document-light.png": 831,
	"./upload-generic-error.png": 832,
	"./upload-generic-success.png": 833,
	"./upload-generic.png": 834,
	"./upload-pof-back-card-error.png": 835,
	"./upload-pof-back-card-success.png": 836,
	"./upload-pof-back-card.png": 837,
	"./upload-pof-front-card-error.png": 838,
	"./upload-pof-front-card-success.png": 839,
	"./upload-pof-front-card.png": 840,
	"./upload-poi-back-drivingLicense-error.png": 841,
	"./upload-poi-back-drivingLicense-success.png": 842,
	"./upload-poi-back-drivingLicense.png": 843,
	"./upload-poi-back-error.png": 844,
	"./upload-poi-back-success.png": 845,
	"./upload-poi-back.png": 846,
	"./upload-poi-front-drivingLicense-error.png": 847,
	"./upload-poi-front-drivingLicense-success.png": 848,
	"./upload-poi-front-drivingLicense.png": 849,
	"./upload-poi-front-error.png": 850,
	"./upload-poi-front-success.png": 851,
	"./upload-poi-front.png": 852,
	"./upload-por-front-error.png": 853,
	"./upload-por-front-proofOfResidence-error.png": 854,
	"./upload-por-front-proofOfResidence-success.png": 855,
	"./upload-por-front-proofOfResidence.png": 856,
	"./upload-por-front-success.png": 857,
	"./upload-por-front-utilityBill-error.png": 858,
	"./upload-por-front-utilityBill-success.png": 859,
	"./upload-por-front-utilityBill.png": 860,
	"./upload-por-front.png": 861,
	"./usd.png": 862,
	"./visa.png": 863,
	"./visa_logo_icon.svg": 864,
	"./vps-enter-credentials.png": 865,
	"./vps-remote-desktop-windows.png": 866,
	"./vps-remote-desktop.png": 867,
	"./waiting-list-skip-dark.png": 868,
	"./waiting-list-skip.png": 869,
	"./windows-brands.svg": 870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 873;